import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import AccessFeature from '~components/AccessFeature';

import { ReportsDownloadSectionWrappersSectionItemProps } from './types';

const ReportsDownloadSectionWrapperSectionItem = ({
  title,
  validSubscriptionFeature,
  children,
}: ReportsDownloadSectionWrappersSectionItemProps): ReactElement => {
  return (
    <Stack spacing={2} flex={0.5}>
      <AccessFeature.Typograghy
        {...validSubscriptionFeature}
        variant="body1"
        component="h4"
        fontWeight="bold"
      >
        {title}
      </AccessFeature.Typograghy>

      <AccessFeature.Alert {...validSubscriptionFeature} />

      <AccessFeature.Hidden {...validSubscriptionFeature} type="notAccess">
        {children}
      </AccessFeature.Hidden>
    </Stack>
  );
};

export default ReportsDownloadSectionWrapperSectionItem;
